module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kKi5Q"))).then(() => parcelRequire('hEqeo'));